"use client";

import { getPriceIconUrl, type PriceDisplay } from "@calcom/lib/priceLabel";
import type { ReactNode } from "react";
import { createContext, useContext, useMemo } from "react";

type BookingPageSettings = { priceDisplay: PriceDisplay; priceIconUrl: string };

const BookingPageSettingsContext = createContext<BookingPageSettings>({
  priceDisplay: "both",
  priceIconUrl: getPriceIconUrl(),
});

/** The page owner's display settings, for components deep in the Booker that only get the event. */
export function BookingPageSettingsProvider({
  priceDisplay,
  priceIconUrl,
  children,
}: {
  priceDisplay: PriceDisplay | null;
  priceIconUrl: string;
  children: ReactNode;
}) {
  const value = useMemo(
    () => ({ priceDisplay: priceDisplay ?? "both", priceIconUrl }),
    [priceDisplay, priceIconUrl]
  );
  return <BookingPageSettingsContext.Provider value={value}>{children}</BookingPageSettingsContext.Provider>;
}

export const useBookingPageSettings = () => useContext(BookingPageSettingsContext);
